/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `people_served` - People served
* `money_spent` - Money spent
* `money_earned` - Money earned
 */
export type ContextMetricEnum = typeof ContextMetricEnum[keyof typeof ContextMetricEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContextMetricEnum = {
  people_served: 'people_served',
  money_spent: 'money_spent',
  money_earned: 'money_earned',
} as const;
